const HELP_TEXTS = {
  actionButtons: {
    exportOpportunities:
      'An exhaustive export of this list will be sent to you shortly by Email. It can take a few minutes for the Email to be sent.',
  },
  navigation: {
    cloneOpportunity: 'Clone this Opportunity and its Primary Quote (if any)',
    invoicingIsMissingPrimaryQuote:
      'Please create a Quote for this Opportunity to use Invoicing',
    currentAgreedStatus:
      'Opportunities with start date in the past are filtered out of this view',
  },
  agreements: {
    budget:
      'The part of Opportunity budget belonging to the respective Agreement',
  },
  readOnlyFields: {
    campaignObjective:
      'The campaign objective can be edited only in the primary quote once a primary quote is created',
  },
  info: {
    primaryBrand:
      'For Multi-brand campaigns, the copy assets and the LPs will be created for the first Brand inserted here only',
    selfServiceBudget:
      'Sum of Self-Service Net Client and Self-Service Free Service',
    selfServiceSpentBudget:
      'The Self-Service budget that has been spent so far. Sales Cockpit receives it from Data lake daily',
    securedBudget:
      'Sum of all spendable budget for Campaigns that are part of Agreed Opportunities',
    securedPushedBudget:
      'Sum of all spendable budgets for Campaigns that are Pushed or Locked and part of Agreed Opportunities',
    expectedRevenue:
      'For Managed Service and Subscription, the Expected Revenue is an initial estimation of the PC regarding what the client might invest in this Opportunity. For Self Service, this amount represents the initial pushed amount only. In all cases, the amount will not be updated via quote recreations or change requests',
    openBudget: 'Spendable Budget minus Spent Budget',
    netClientBudget:
      'The sum of the NetClientBudgetExternal and WKZBudget that BI will use',
    netClientBudgetExternal:
      'The part of NetClientBudget that will be invoiced to the clients',
    wkzBudget:
      'The part of NetClientBudget that will be invoiced to the WKZ cost center',
    coInvest:
      'Co-Invest is the amount of budget that is invested by Zalando (Category Management, Markets, Marketing). This amount needs to be invoiced to Zalando',
    freeService: 'The free service',
    spendableBudget:
      'The total spendable budget, calculated from NetClientBudget, HeaderDiscount, CoInvest, AdjustedFee and FreeService',
    hasCFCampaignLevelSteering:
      'Enabling this feature will allow CLS (automated budget shift). This is only the initial state in SC and it will not sync, based on the changes on the ad servers',
    hasCCPCampaignLevelSteering:
      'Enabling this feature will allow CLS (automated budget shift). This is only the initial state in SC and it will not sync, based on the changes on the ad servers',
    merchants:
      'If a merchant does not appear in the dropdown, it means this merchant is either not created, or not yet live',
  },
};

export default HELP_TEXTS;
